import { FormControlLabel, Switch } from "@mui/material"

export const Switchs = (props) => {
    return (
        <FormControlLabel
            value="start"
            className='afecto-label'
            checked={props?.checked}
            control={<Switch color="primary" />}
            label={props?.label}
            labelPlacement="start"
            onChange={props?.onChange}
        />
    )
}